"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _nodata_styles = _interopRequireDefault(require("./nodata_styles"));

var _nodata_definition = _interopRequireDefault(require("./nodata_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// material
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : STATE : NODATA ~~~~~~~~~~ ========== */


var NoDataState = (0, _reactJss.default)(_nodata_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "state nodata nodataview ".concat(props.classes.nodataview)
  }, _react.default.createElement(_index.Copy, null, _react.default.createElement(_index.Title, null, "Not Enough Data"), _react.default.createElement(_index.BodyCopy, null, "Unfortunately, you don\u2019t have ", _react.default.createElement("br", null), "enough data to display this element.")));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(NoDataState, _nodata_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = NoDataState;
exports.default = _default;